import { Component, OnInit, Input, NgZone } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject, Subscription } from 'rxjs';
import { GlobalMethodsService } from '../../../services/global-methods.service';

@Component({
  selector: 'app-default-modal',
  templateUrl: './default-modal.component.html',
  styleUrls: ['./default-modal.component.scss'],
})
export class DefaultModalComponent implements OnInit {

  @Input() paramTitle: string;
  @Input() paramText: string;
  @Input() paramMainButton: string;
  @Input() paramSecondButton: string;
  @Input() paramLoadingText: string;
  @Input() paramsAnalytics: any;
  public loading = true;
  private statusLoading = new Subject<boolean>();
  public loadingEvent: Subscription;

  constructor(private modalCtrl: ModalController,
              private zone: NgZone,
              private gms: GlobalMethodsService) {
    this.statusLoadingEvent().subscribe(async (status: boolean) => {
      this.zone.run(async () => {
        this.loading = status;
        this.modalCtrl.dismiss(true);
      });
    });
  }

  ngOnInit() {
    if (this.paramsAnalytics != null && this.paramsAnalytics != ''){
      this.gms.analyticsTrackEvent('openScreen', this.paramsAnalytics);
    }
  }

  ngAfterViewInit() {
    this.loadingEvent = this.statusLoadingEvent().subscribe(async (status: boolean) => {
      this.zone.run(async () => {
        this.loading = status;
        this.modalCtrl.dismiss(true);
      });
    });
  }

  ngOnDestroy() {
    this.loadingEvent.unsubscribe()
  }

  async dismiss(value) {
    await this.modalCtrl.dismiss({result: value});
  }

    /* Loading event
   ================================================== */
   public statusLoadingEvent(): Subject<boolean> {
    return this.statusLoading;
  }

  public setStatusLoading(status) {
    this.statusLoading.next(status);
  }

}
